import { createAction, props } from '@ngrx/store';

//
export const reset = createAction('[BUILDER] Limpiar');

//
export const setMode = createAction('[BUILDER] Set mode', props<{ mode: string }>());

